import React from 'react'

import HeaderWidget from '../../../../../components/atoms/HeaderWidget'

const LeadTime: React.FC = () => {
  return (
    <HeaderWidget
      title='Lead Time'
      information='This metric measures the time elapsed between a task being created and it is completed.'
    >
      -
    </HeaderWidget>
  )
}

export default LeadTime
